<template>
  <span class="bg-red-800 px-0.5 pt-1.5 text-white text-[10px] ml-0.5">GS</span>
</template>

<script lang="ts" setup></script>
<style lang="scss"></style>
